import React from 'react';
import PersonalDataChangeFormSC, {
  PersonalDataChangeFormTextInputSC,
  PersonalDataChangeFormErrorSC,
} from './personal-info-change-form.styled';
import { Formik } from 'formik';
import IbanFormSchema from './personal-info-change-form-rules';
import { HeadingTwo } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import SmallText from '../../typography/small-text';

const PersonalInfoChangeForm = ({ onSubmitForm, userData }) => {
  const initialState = React.useMemo(() => {
    const email = userData.email ? userData.email : '';
    const phone = userData.phone_number ? userData.phone_number : '';
    return { email, phone };
  }, [userData]);

  return (
    <PersonalDataChangeFormSC>
      <Formik
        enableReinitialize
        initialValues={initialState}
        validationSchema={IbanFormSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          const formattedValues = {
            email: values.email.replace(/ /g, ''),
            phone: values.phone.replace(/ /g, ''),
          };
          onSubmitForm(formattedValues);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
          const emailHasError = errors && errors.email && touched.email;
          const phoneHasError = errors && errors.phone && touched.phone;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="top-text-wrap">
                  <HeadingTwo className="bold">
                    <FormattedHTMLMessage
                      id="profile_personal_info_change_form_title"
                      defaultMessage={dlt['profile_personal_info_change_form_title']}
                    />
                  </HeadingTwo>
                </div>

                <div className="full-block">
                  <SmallText className="smaller bolder input-label">
                    <FormattedMessage
                      id="requests_form_personal_data_email_label"
                      defaultMessage={dlt['requests_form_personal_data_email_label']}
                    />
                  </SmallText>

                  <PersonalDataChangeFormTextInputSC
                    type="text"
                    name="email"
                    filled={values.email}
                    hasError={emailHasError}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email || ''}
                  />

                  {emailHasError ? (
                    <PersonalDataChangeFormErrorSC>
                      <FormattedMessage id={errors.email} defaultMessage={dlt[errors.email]} />
                    </PersonalDataChangeFormErrorSC>
                  ) : null}
                </div>

                <div className="full-block">
                  <SmallText className="smaller bolder input-label">
                    <FormattedMessage
                      id="requests_form_personal_data_phone_label"
                      defaultMessage={dlt['requests_form_personal_data_phone_label']}
                    />
                  </SmallText>

                  <PersonalDataChangeFormTextInputSC
                    type="text"
                    name="phone"
                    filled={values.phone}
                    hasError={phoneHasError}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone || ''}
                  />

                  {phoneHasError ? (
                    <PersonalDataChangeFormErrorSC>
                      <FormattedMessage id={errors.phone} defaultMessage={dlt[errors.phone]} />
                    </PersonalDataChangeFormErrorSC>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="full-block">
                  {/*    <BiggerText>
                    <FormattedMessage
                      id="requests_form_continue_hint"
                      defaultMessage={dlt['requests_form_continue_hint']}
                    />
                  </BiggerText> */}
                  <Button type="PRIMARY" className="form-submit" onClick={handleSubmit} withIcon>
                    <FormattedMessage
                      id="global_continue"
                      defaultMessage={dlt['global_continue']}
                    />
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </PersonalDataChangeFormSC>
  );
};

export default PersonalInfoChangeForm;
